// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__SO0iM","terms":"styles_terms__dHAlp","spin":"styles_spin__Z2em9"};